import pxToRem from "../../functions/pxToRem";

export default function autocomplete({ boxShadows, typography, colors, borders }) {
  const { lg } = boxShadows;
  const { size } = typography;
  const { text, white, transparent, light, gradients, background } = colors;
  const { borderRadius } = borders;

  const autocomplete = {
    styleOverrides: {
      popper: {
        boxShadow: lg,
        padding: pxToRem(8),
        fontSize: size.sm,
        color: text.main,
        textAlign: "left",
        backgroundColor: `${background.paper} !important`,
        borderRadius: borderRadius.md,
      },

      paper: {
        boxShadow: "none",
        backgroundColor: transparent.main,
      },

      option: {
        padding: `${pxToRem(4.8)} ${pxToRem(16)}`,
        borderRadius: borderRadius.md,
        fontSize: size.sm,
        color: text.main,
        transition: "background-color 300ms ease, color 300ms ease",

        "&:hover, &:focus, &.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus": {
          backgroundColor: light.main,
          color: text.primary,
        },

        '&[aria-selected="true"]': {
          backgroundColor: `${light.main} !important`,
          color: `${text.primary} !important`,
        },
      },

      noOptions: {
        fontSize: size.sm,
        color: text.main,
      },

      groupLabel: {
        color: text.primary,
      },

      loading: {
        fontSize: size.sm,
        color: text.main,
      },

      tag: {
        display: "flex",
        alignItems: "center",
        height: "auto",
        padding: pxToRem(4),
        backgroundColor: gradients.dark.state,
        color: white.main,

        "& .MuiChip-label": {
          lineHeight: 1.2,
          padding: `0 ${pxToRem(10)} 0 ${pxToRem(4)}`,
        },

        "& .MuiSvgIcon-root, & .MuiSvgIcon-root:hover, & .MuiSvgIcon-root:focus": {
          color: white.main,
          marginRight: 0,
        },
      },
    },
  };

  return autocomplete;
}
